import React from 'react';
import { IBulletinMessage } from './interfaces';
import { BulletinBoardService } from './BulletinBoardService';

export function Messages(messages: IBulletinMessage[], widgetId: string) {
  return (
    <>
      <div className='row mb-2'>
        <div className='col'>
          <h2>Bekijk berichten</h2>
        </div>
      </div>

      <div className="row">
        <div className="col">

          <div id={"message-accordion-" + widgetId}>

            {messages.map((message, index) => {
              var mymessage = 'message' + message.messageId;
              var myreactions = 'reactions' + message.messageId;
              return (
                <div className="mb-3" key={message.messageId}>

                  <div className="widget-bulletin-board__message px-4 pt-3 pb-2" onClick={BulletinBoardService.SetSelectedMessage}
                    id={mymessage} data-toggle="collapse" data-target={"#" + myreactions} aria-controls={myreactions}>
                    <h4 className='mt-0'>{message.title}</h4>
                    <p><span className='author'>{message.author}</span> <span className='small'>{message.createdDateTime}</span></p>
                    <p>{message.message}</p>
                    {message.reactions.length > 0 &&
                      <p><strong><span className="icon icon2-bubbles"></span> {message.reactions.length} reactie{"(s)"}</strong></p>
                    }
                    {message.reactions.length == 0 &&
                      <p><strong><span className="icon icon2-bubbles"></span> reageren</strong></p>
                    }
                  </div>

                  <div id={myreactions} className="collapse" aria-labelledby={mymessage} data-parent={"#message-accordion-" + widgetId}>

                    <div className="widget-bulletin-board__reaction form px-4 pt-3 pb-2 ms-5 ml-5 mt-3" data-parentid={message.messageId}>

                      <div className="row">
                        <div className="col">
                          <div className="form-group form__section-input mb-2">
                            <label htmlFor="message">Reageer op bericht</label>
                            <div className="input-group">
                              <textarea id={'Reaction-' + message.messageId} onKeyUp={BulletinBoardService.CharCounter} name="reaction" required autoComplete="" placeholder="" className="form-control" rows={3} maxLength={300}></textarea>
                            </div>
                            <div id="the-message-counter-@widgetId">
                              <p className='m-0'>
                                <span className="current">0</span>
                                <span className="maximum"> / 300</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col">
                          <div className="form-group mb-1 text-end text-right">
                            <button type="submit" onClick={BulletinBoardService.PostReaction} className="button-form-control btn btn-primary btn-reaction" data-parentid={message.messageId}>Plaats reactie</button>
                          </div>
                        </div>
                      </div>

                      <div className='row'>
                        <div className="col">
                          <div className='alert alert-success d-none'>
                              Je reactie is ontvangen, het kan tot 24 uur duren voordat je reactie zichtbaar is.
                          </div>
                          <div className='alert alert-warning d-none'>
                              Je reactie is niet bewaard, controleer je invoer.
                          </div>
                        </div>
                      </div>

                    </div>

                    {message.reactions?.map((reaction, mindex) => {
                      return (

                        <div className="widget-bulletin-board__reaction px-4 pt-3 pb-2 ms-5 ml-5 mt-3" key={reaction.reactionId}>
                          <p><strong>{reaction.author}</strong> <small>{reaction.createdDateTime}</small></p>
                          <p>
                            {reaction.message}
                          </p>
                        </div>

                      );
                    })}
                  </div>
                </div>
              );
            })}

          </div>
        </div>
      </div>
    </>
  );
}